// Webpack Imports
import * as bootstrap from 'bootstrap';

// Default SortableJS
import Sortable from 'sortablejs';

		
var scrolled = false;

( function () {
	'use strict';

	//Dropzone.autoDiscover = false;

	const forms = document.querySelectorAll('.needs-validation');

	// Loop over them and prevent submission
	Array.prototype.slice.call(forms).forEach((form) => {
	  form.addEventListener('submit', (event) => {
		if (!form.checkValidity()) {
		  event.preventDefault();
		  event.stopPropagation();
		}
		form.classList.add('validated');
	  }, false);
	});
	function initializeMap() {
	
		var s = $("#map"),
		customMarkerUrl = s.attr('data-map-marker'),
		latitude = s.attr('data-center-lat'),
		longitude = s.attr('data-center-lng'),
		locations = JSON.parse(s.attr('data-locations')),
		center = true;
	
		if (latitude == null) {
			latitude = 54.6993273;
			longitude = 24.6787872;
		} else {
			center = false
		}
	
		var map = new google.maps.Map(document.getElementById('map'), {
			zoom: 12,
			center: new google.maps.LatLng(latitude,longitude),
		});
	
		var infowindow = new google.maps.InfoWindow();
	
		var marker, i;
	
		var icon = {
			url: customMarkerUrl,
			scaledSize: new google.maps.Size(34, 44),
			labelOrigin: new google.maps.Point(17, 19)
		}; 
	
		var marker = new google.maps.Marker({
			map: map,
			animation: google.maps.Animation.DROP,
			icon : icon,
		});    
		
		var boundbox = new google.maps.LatLngBounds();
	
		for (i = 0; i < locations.length; i++) {
			marker = new google.maps.Marker({
				position: new google.maps.LatLng(locations[i][1], locations[i][2]),
				map: map,
				icon : icon,
				label: {
					text: locations[i][4],
					color: '#2D333B',
					fontSize: '12px', 
					fontFamily: 'Roboto',
					fontWeight: 'bold'					
				}
			});

			if(center) {
			
				google.maps.event.addListener(marker, 'click', (function (marker, i) {
					return function () {
						window.location.href = locations[i][5];
					}
				})(marker, i));
			}

			boundbox.extend(new google.maps.LatLng(locations[i][1], locations[i][2]));
		} 

		if(center) {
	
			map.setCenter(boundbox.getCenter());

			if(locations.length > 1) {

				map.fitBounds(boundbox); 
			}
		}          
	
	}
	function elementInViewport(myElement) {
	
		if (typeof(myElement) != 'undefined' && myElement != null) {
			
			var bounding = myElement.getBoundingClientRect();
			var myElementHeight = myElement.offsetHeight;
			var myElementWidth = myElement.offsetWidth;
	
			if (bounding.top >= -myElementHeight 
				&& bounding.left >= -myElementWidth
				&& bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
				&& bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) {
				
				if(!scrolled) {
	
					initializeMap();
				}
				
				scrolled = true;
			}
		}
	}

	window.addEventListener('load', function() {
		elementInViewport(document.getElementById('map'));
	});

	window.addEventListener('scroll', function() {
		elementInViewport(document.getElementById('map'));
	});

	// Autocomplete address
	var options = {
	types: ['address'],
	};
	
	var input = document.getElementById('floatingAddress');
	new google.maps.places.Autocomplete(input, options);

} )();

if ($('.se-F').length) {

	var searchFromTop = $('.se-F').offset().top;
}

$( document ).ready(function() {


	if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
		$('body').addClass('safari-mac');
	}

	// Lightbox

	$('.gallery-list').magnificPopup({
		delegate: 'a',
		type: 'image',
		gallery:{
		  enabled:true
		}
	});

	
	// Languages

	

	$(".language > li").each(function(){
		
		var s = $(this),
		btn = s.find('.btn');

		btn.on( "click", function() {
			
			if(!s.hasClass('open')) {
				$(".language > li").removeClass('open');
				s.addClass('open');
			}
		});
	});

	

	// Modal close
	
	$(".modal").on("shown.bs.modal", function()  { // any time a modal is shown
		var urlReplace = "#" + $(this).attr('id'); // make the hash the id of the modal shown
		history.pushState(null, null, urlReplace); // push state that hash into the url
	});
	$(window).on('popstate', function() { 
		$(".modal").modal('hide');
	});

	// modal to top
	$( '[data-bs-toggle="modal"]' ).on( "click", function() {
		
		window.scrollTo(0, 0);
	});

	// Navbar toggler
	

	$( ".navbar-toggler" ).on( "click", function() {
		var s = $(this);
		
		if(s.hasClass('collapsed')) {
			$( "body" ).removeClass('no-scrl');
		} else {
			$( "body" ).addClass('no-scrl');
		}
	});

	

	

	// Select class

	$('body').on('change', 'select', function() {
		$(this).addClass('on');
	});


	

	$( '.load-posts' ).each( function() {
    

		var wrapper = $(this),
		group = wrapper.find('.post-group'),
		// .sb must be first
		itemsSelector = '.item',
		items = $(itemsSelector, wrapper);
	
	  	var navElement = $('.pg-nav', wrapper);
	
	
	  	if (navElement.length) {
	
		var loadTrigger = $('.nxt a', navElement);
	
			if (loadTrigger.length) {
		
			var dataType = 'html';
		
				loadTrigger.click(function (e) {
			
					e.preventDefault();
			
					var total = parseFloat(navElement.attr('data-stats-count-posts')),
					perPage = parseFloat(navElement.attr('data-stats-posts-per-page')),
					showingPosts = parseFloat(navElement.attr('data-stats-showing-posts'));
			
					loadTrigger.addClass('wait');
			
					var url = loadTrigger.attr('href');
			
					$.ajax({
					type: "GET",
					url: url,
					dataType: dataType
					}).done(function (data) {
			
					var dType = (typeof data);
			
					if (dType === 'object' && data.count == 0) return;
			
					var lastItem = $(itemsSelector, group).last(),
						html,
						itemsLoaded,
						newTriggerURL;
			
					if (dType === 'object') {
			
						html = data.html.toString();
						var contain = $(html);
						contain.wrap('<div />');
						contain = contain.parent();
						html = contain.html();
						itemsLoaded = data.count;
						newTriggerURL = data.candidate_url;
			
					} else if (dataType == 'html') {
			
						var innerListing = $(data).find('.post-list'),
						innerGroup = $('> .post-group', innerListing),
						newTriggerURL = innerListing.find('.pg-nav .nxt a').attr('href');
			
						innerListing.find('.pg-nav').remove().end();
						html = innerGroup.html();
						itemsLoaded = $(itemsSelector, innerGroup).length;
			
					}
			
					var showingPostsNow = (showingPosts + parseFloat(itemsLoaded)),
						remaining = (total - showingPostsNow);
			
					navElement.attr('data-stats-showing-posts', showingPostsNow);
			
			
					loadTrigger.removeClass('wait');
					lastItem.after(html);
			
					if (remaining <= 0) {
			
						navElement.hide();
					}
			
					if (remaining > 0) {
						loadTrigger.attr('href', newTriggerURL);
					}
			
					});
			
				});

			}
		}
	} );


	// More filter

	function more_services() {


		$( '.box-choice' ).each( function() {

			var s = $(this),
			more = s.find('.more'),
			show = s.find('.show');
	
			if(more.length) {
	
				show.on( "click", function(e) {
					e.preventDefault();
					more.toggleClass('on');
				});
			}
		} );
	}

	more_services();

	

});
$(window).bind("load resize scroll",function(e){


	if ($(window).scrollTop() > searchFromTop) {
		$('.se-F').addClass('on');
	} else {
		$('.se-F').removeClass('on');
	}

	if($('.f-src').height() > $(window).height()) {
		$('.f-src .collapse').addClass('overflow');
	}

});

AOS.init({
	duration: 1200,
	once: true,
	offset: 100,
})
  